// extracted by mini-css-extract-plugin
module.exports = {"sceneDetailPage":"SceneDetailPage_sceneDetailPage__1Vgaq"};